import { Component, OnInit, ViewChild } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { Validators, FormGroup, FormBuilder } from '@angular/forms';
import { UserService } from '../../../../services/user.service';
import { AuthenticationService } from '../../../../services/student-authentication.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { ErrorService } from 'app/shared/services/error.service';
import { AppLoaderService } from 'app/shared/services/app-loader/app-loader.service';

@Component({
    selector: 'app-email-verification',
    templateUrl: '../email-verification/email-verification.component.html',
    styleUrls: ['../email-verification/email-verification.component.scss'],
})
export class EmailVerificationComponent implements OnInit {
    @ViewChild(MatButton) submitButton: MatButton;
    user = {
        email: '',
    };
    emailVerificationForm: FormGroup;
    showEmailVerificationInvalid = false;
    emailVerificationErrorMessage: string;

    error_messages = {
        email: [
            { type: 'required', message: 'Please enter your email' },
            { type: 'email', message: 'Please provide a valid email' },
        ],
        code: [
            { type: 'required', message: 'Please enter your confirmation code.' },
        ],
    };

    constructor(
        private formBuilder: FormBuilder,
        private userService: UserService,
        private authenticationService: AuthenticationService,
        private _snackBar: MatSnackBar,
        private router: Router,
        private errorService: ErrorService,
        private loader: AppLoaderService
    ) {}

    ngOnInit() {
        if (this.userService.user?.username) {
            this.user.email = this.userService.user.username;
        }
        this.emailVerificationForm = this.formBuilder.group({
            email: [this.user.email, [Validators.required, Validators.email]],
            code: ['', Validators.required],
        });
    }

    get formControls() {
        return this.emailVerificationForm.controls;
    }

    async resendConfirmedCode() {
        try {
            this.loader.open('Please wait');
            await this.authenticationService.resendConfirmedCode(
                this.emailVerificationForm.value.email
            );
            this.loader.close();
            this._snackBar.open(
                'Confirmation code sent successfully.',
                'Close',
                {
                    duration: 8000,
                    panelClass: ['success-snackbar'],
                }
            );
        } catch (err) {
            this.loader.close();
            this.showEmailVerificationInvalid = true;
            this.emailVerificationErrorMessage = this.errorService.mapError(
                JSON.parse(err.response).message
            );
        }
    }

    async onSubmit() {
        if (!this.emailVerificationForm.invalid) {
            this.showEmailVerificationInvalid = false;
            const verifyEmailData = this.emailVerificationForm.value;
            this.userService.user.username = verifyEmailData.email;
            this.userService.user.code = verifyEmailData.code;

            try {
                this.loader.open('Please wait');
                if (
                    this.userService.user.username &&
                    this.userService.user.password
                ) {
                    await this.authenticationService.verifyEmail(
                        this.userService.user
                    );
                    this._snackBar.open(
                        'Email verification successful.',
                        'Close',
                        {
                            duration: 8000,
                            panelClass: ['success-snackbar'],
                        }
                    );

                    await this.authenticationService.login(
                        this.userService.user.username,
                        this.userService.user.password
                    );
                    this.loader.close();
                    this.userService.setClaims();

                    this.router.navigate(['/']);
                }

            } catch (err) {
                this.loader.close();
                this.showEmailVerificationInvalid = true;
                this.emailVerificationErrorMessage = this.errorService.mapError(
                    JSON.parse(err.response).message
                );
            }
        }
    }
}
